<template>
  <div style="color: #888888;">
    Loading...
  </div>
</template>

<script>
export default {};
</script>
